import { render, staticRenderFns } from "./recover.vue?vue&type=template&id=33a7b7db&scoped=true"
import script from "./recover.vue?vue&type=script&lang=js"
export * from "./recover.vue?vue&type=script&lang=js"
import style0 from "./recover.vue?vue&type=style&index=0&id=33a7b7db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a7b7db",
  null
  
)

export default component.exports